import { createSelector } from '@ngrx/store';

import { getPaymentState } from '../getPaymentState';

export const getRedemptionRates = createSelector(getPaymentState, (paymentState) => paymentState.redemptionRates);
